var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-actions"},[_c('ul',{staticClass:"nav-aba"},_vm._l((_vm.apps),function(app){return _c('li',{key:app.name,on:{"click":function($event){return _vm.openApp(app)}}},[_c('a',{class:{ativo: _vm.active === app.name}},[_c('i',{class:app.icon}),_vm._v(" "+_vm._s(app.label))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }